import { IMedsusItem } from '../../modules/types/Medsus';
import httpClient from '../httpClient';

export const getAllMedsusItem = async () => {
  try {
    const response = await httpClient.get(`/api/vmp/diretrizes`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

export async function getAllMedicamentosByDiretrizesAtivasPublic() {
  try {
    const response = await httpClient.get(`/api/vmp/diretrizes/public`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getDiretrizesByMedicamentoPublic(id: string) {
  try {
    const response = await httpClient.get(`/api/vmp/public/${id}/diretrizes`);
    return response.data ? response.data : null;
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getAllMedicamentosByDiretrizesAtivas() {
  try {
    const response = await httpClient.get(`/api/vmp/diretrizes`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getMedsusItem(id: string) {
  try {
    const response = await httpClient.get(`/api/vmp/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function handleCreateMedsusItem(form: IMedsusItem) {
  try {
    const response = await httpClient.post(`/api/vmp`, form);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function handleUpdateMedsusItem(form: IMedsusItem) {
  try {
    const response = await httpClient.patch(`/api/vmp/${form.id}`, form);

    return response;
  } catch (error) {
    throw error;
  }
}

export async function handleDeleteMedsusItem(id: string | number) {
  try {
    return await httpClient.delete(`/api/vmp/${id}`);
  } catch (error) {
    throw error;
  }
}

export const getAllProdutoVmp = async () => {
  try {
    const response = await httpClient.get('api/vmp');
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};
